import { createHashParamRouter } from '@vkontakte/vk-mini-apps-router';

export const DEFAULT_VIEW = 'default_view';
export const HOME_PANEL = 'home_panel';
export const CATEGORY_PANEL = 'category_panel';
export const WORD_PANEL = 'word_panel';
export const DAILY_PANEL = 'daily_panel';
export const TRAINING_PANEL = 'training_panel';
export const RATING_PANEL = 'rating_panel';
export const CABINET_PANEL = 'cabinet_panel';
export const DICTIONARY_PANEL = 'dictionary_panel';
export const ACHIEVEMENTS_PANEL = 'achievements_panel';

export const router = createHashParamRouter([
  { path: '/', panel: HOME_PANEL, view: DEFAULT_VIEW },
  { path: '/category/:categoryId', panel: CATEGORY_PANEL, view: DEFAULT_VIEW },
  { path: '/word/:wordId', panel: WORD_PANEL, view: DEFAULT_VIEW },
  { path: '/daily', panel: DAILY_PANEL, view: DEFAULT_VIEW },
  { path: '/training', panel: TRAINING_PANEL, view: DEFAULT_VIEW },
  { path: '/rating', panel: RATING_PANEL, view: DEFAULT_VIEW },
  { path: '/cabinet', panel: CABINET_PANEL, view: DEFAULT_VIEW },
  { path: '/dictionary', panel: DICTIONARY_PANEL, view: DEFAULT_VIEW },
  { path: '/achievements', panel: ACHIEVEMENTS_PANEL, view: DEFAULT_VIEW }
]);
